import React from "react"
import { Grid, Typography } from "@mui/material"
import { CardSeeker, CountUpSeeker, IconSeeker, LoadingIconSeeker } from "@ui-seeker/core"


export default function AppAnalyticsCard({ isLoading, iconColor, label, countUp, icon }) {

	return <CardSeeker
		sx={{
			boxShadow: 'none',
			border: 'none',
			p: 0,
			py: 0.5,
			m: 0,
			width: "100%",
			height: "100%",
		}}
		variant="plain">
		<Grid container sx={{ p: 0, height: "100%" }}>
			<Grid item xs={4}
				  sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				{isLoading
					? <LoadingIconSeeker sx={{ color: iconColor, fontSize: "2vw", }}/>
					: <IconSeeker icon={icon} sx={{
						color: iconColor,
						fontSize: "2vw",
					}}/>}

			</Grid>
			<Grid item xs={8}>
				<Grid item xs={12}>
					<Typography sx={{ fontSize: "1.1vw" }} color="secondary.main">{label}</Typography>
				</Grid>
				<Grid item xs={12} sx={{
					display: 'flex',
					alignItems: 'center',
					flexDirection: "row",
					fontWeight: "bold",
					fontSize: "1.2vw",
					color: "secondary.main"
				}}>
					<CountUpSeeker end={countUp}/>
				</Grid>
			</Grid>
		</Grid>
	</CardSeeker>
}